export default () => ({
  prefixRouter: 'professional.company.employees'
})



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/resources/data.js